import React, { useEffect } from "react";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  Button,
  Table,
  Card,
  Form,
  FormCheck,
  Collapse,
} from "react-bootstrap";
import { toast } from "react-toastify";

function CopyLifeCycleFields({ show, setShow, onCopy, module_id }) {
  const allFields = [
    "Order Type",
    "Contract Vehicle",
    "Organization Name",
    "Order Description",
    "Date Created",
    "Estimated Date Fulfilled",
    "Actual Date Fulfilled",
    "Custom fields",
    // step 2
    "chain of custody",
    // step 3
    "Contracting  Name",
    "Contracting Email",
    "Contracting Phone",
    "Contracting Address",

    "Shipping Name",
    "Shipping Email",
    "Shipping Phone",
    "Shipping Address",

    "Billing Name",
    "Billing Email",
    "Billing Phone",
    "Billing Address",

    "Shipping Method",
    "Shipping Terms",
    "Estimated Delivery",
    "Payment Terms",
    "Shipping Cost($)",
    "Tax($)",
    "Other Cost",
    "Total Cost Before Margin($)",
    "Total Cost After Margin($)",

    "Product",
    // "Order Vendor",
  ];
  const [selectedFields, setSelectedFields] = useState(allFields);
  const [pickFields, setPickFields] = useState(false);
  
  const handleFieldChange = (field) => {
    setSelectedFields((prev) =>
      prev.includes(field)
        ? prev.filter((item) => item !== field)
        : [...prev, field]
    );
  };
  const handleAllFieldsToggle = () => {
    setPickFields(false);
    setSelectedFields(allFields);
  };

  const handlePickFieldsToggle = () => {
    setPickFields(true);
    setSelectedFields([]);
  };

  const handleCopy = () => {
    if (!selectedFields) {
      toast.error("Please select an option to copy!");
      return;
    }
    onCopy(selectedFields, module_id);
    setShow({ show: false });
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow({ show: false })}
      className="skusearch"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header className="gap-2 align-items-center" closeButton>
        <Modal.Title>Copy Lifecycle</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="excel_checkbox">
            <FormCheck
              className="mb-2"
              type="checkbox"
              label="All Fields"
              checked={!pickFields}
              onChange={handleAllFieldsToggle}
            />
            <FormCheck
              className="mb-2"
              type="checkbox"
              label="Pick Fields"
              checked={pickFields}
              onChange={handlePickFieldsToggle}
            />
          </Form.Group>
          <Collapse in={pickFields}>
            <div className="excel_checkbox">
              {allFields.map((field) => (
                <FormCheck
                  key={field}
                  type="checkbox"
                  label={field}
                  checked={selectedFields.includes(field)}
                  onChange={() => handleFieldChange(field)}
                />
              ))}
            </div>
          </Collapse>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn-warning"
          onClick={() => handleCopy(selectedFields)}
        >
          Copy
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CopyLifeCycleFields;